import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProgressButtons from '../../common/components/ProgressButtons';
import TransportModes from './TransportModes';
import TransportModeSelectorContainer from './TransportModeSelectorContainer';
import sc from '../../../common/redux/actions/types/SelectionCriteriaTypes';
import scDefinitions from '../../../common/config/SelectionCriteriaDefinitions';
import ReportDefinitions from '../../../common/config/ReportDefinitions';

const SC_CODE = sc.SC070;

class TransportModeSelectorWizardContainer extends Component {
  hasAtLeastOneSelectedTransportMode = () =>
    Object.keys(this.props.transportModeSelector)
      .some(legCode => this.props.transportModeSelector[legCode].selected.length > 0);

  render() {
    const reportId = this.props.match.params.reportName;
    const selectionCriteria = ReportDefinitions[reportId].selectionCriteria.items;
    const nextSelectionCriteriaRouteName = (
      scDefinitions[selectionCriteria[selectionCriteria.indexOf(SC_CODE) + 1]] || {}
    ).routeName;

    return (
      <div className="product-selection-wrapper">
        <div className="product-selection">
          <div className="product-selection-content">
            <div className="product-tree">
              <TransportModeSelectorContainer
                transportMode={TransportModes.Any}
                legsToBeClearedAfterSelect={[TransportModes.Each.legCode]}
                selectAllOnLoad={this.hasAtLeastOneSelectedTransportMode() === false}
              />
            </div>

            <div className="product-tree">
              <TransportModeSelectorContainer
                transportMode={TransportModes.First}
                legsToBeClearedAfterSelect={[TransportModes.Each.legCode]}
              />
            </div>

            <div className="product-tree">
              <TransportModeSelectorContainer
                transportMode={TransportModes.Last}
                legsToBeClearedAfterSelect={[TransportModes.Each.legCode]}
              />
            </div>

            <div className="product-tree">
              <TransportModeSelectorContainer
                transportMode={TransportModes.Each}
                legsToBeClearedAfterSelect={[
                  TransportModes.Any.legCode,
                  TransportModes.First.legCode,
                  TransportModes.Last.legCode,
                ]}
                isRadioGroup
              />
            </div>
          </div>

          <div className="product-selection-footer">
            <div className="product-selection-footer__action right">
              <div className="actions">
                <ProgressButtons
                  next={this.props.children.routes[nextSelectionCriteriaRouteName]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    transportModeSelector: state.transportModeSelector,
  };
}

TransportModeSelectorWizardContainer.propTypes = {
  routes: PropTypes.objectOf(PropTypes.shape).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      reportName: PropTypes.string,
    }),
  }),
  transportModeSelector: PropTypes.objectOf(PropTypes.shape),
};

export const ConnectedTransportModeSelectorWizardContainer =
  connect(mapStateToProps)(TransportModeSelectorWizardContainer);

export default (ConnectedTransportModeSelectorWizardContainer);
